import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Modal, Select, DatePicker, Row, Col } from 'antd';
import useAxios from '../../../CustomHooks/useAxios';
import moment from 'moment';
import './Add.css';
import { phanloaiKhachHang, kenh_array } from './phanloaiKhachHang';
export default function Add({ visible, onClose, onSuccess }) {
  const [form] = Form.useForm();
  const { axiosi } = useAxios();
  const [companies, setCompanies] = useState([]);
  const [hdtnphongban, setHdtnphongban] = useState([]);
  const [hdtnlydo, setHdtnlydo] = useState([]);
  const [hdticket2phanloai, setHdticket2phanloai] = useState([]);
  const [hdtkstatus, setHdtkstatus] = useState([]);
  // const [searchValue, setSearchValue] = useState('');
  const handleSubmit = async (values) => {
    try {
      await axiosi.post('/hdticket', values);
      form.resetFields();
      onSuccess();
    } catch (error) {
      console.error('Error creating ticket:', error);
    }
  };

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        // Cân nhắc thêm state loading ở đây (ví dụ: setLoading(true))
        const [
          companiesRes,
          phongbanRes,
          lydoRes,
          phanloaiTicketRes,
          tkstatusRes,
        ] = await Promise.all([
          axiosi.get(`${process.env.REACT_APP_API_URL}/hdcompany/hang`),
          axiosi.get(`${process.env.REACT_APP_API_URL}/hdtnphongban`),
          axiosi.get(`${process.env.REACT_APP_API_URL}/hdtnlydo`),
          axiosi.get(`${process.env.REACT_APP_API_URL}/hdticket2phanloai`),
          axiosi.get(`${process.env.REACT_APP_API_URL}/hdtkstatus`),
        ]);

        setCompanies(companiesRes.data.rows);
        setHdtnphongban(phongbanRes.data.rows);
        setHdtnlydo(lydoRes.data.rows);
        setHdticket2phanloai(phanloaiTicketRes.data.rows);
        setHdtkstatus(tkstatusRes.data.rows);
      } catch (error) {
        console.error('Error fetching initial data:', error);
        // Xử lý lỗi một cách cụ thể hơn nếu cần, ví dụ: hiển thị thông báo cho người dùng
      } finally {
        // setLoading(false);
      }
    };

    fetchInitialData();
  }, []); // Thêm axiosi vào dependency array nếu nó được đảm bảo là ổn định hoặc nếu logic trong useAxios thay đổi.
  // Nếu axiosi không bao giờ thay đổi, bạn có thể để mảng rỗng [].

  // useEffect(() => {
  //   const fetchCompanies = async () => {
  //     try {
  //       const response = await axiosi.get(`${process.env.REACT_APP_API_URL}/hdcompany/hang`);
  //       console.log(response.data);
  //       // const hangList = response.data.rows.filter(item => item.type === 'hang');
  //       setCompanies(response.data.rows);
  //     } catch (error) {
  //       console.error('Error fetching companies:', error);
  //     }
  //   };
  //   fetchCompanies();
  // }, []);

  // useEffect(() => {
  //   const fetchHdtnphongban = async () => {
  //     try {
  //       const response = await axiosi.get(`${process.env.REACT_APP_API_URL}/hdtnphongban`);
  //       setHdtnphongban(response.data.rows);    
  //     } catch (error) {
  //       console.error('Error fetching companies:', error);
  //     }
  //   };
  //   fetchHdtnphongban();  
  // },[])

  // useEffect(() => {
  //   const fetchHdtnlydo = async () => {
  //     try {
  //       const response = await axiosi.get(`${process.env.REACT_APP_API_URL}/hdtnlydo`);
  //       setHdtnlydo(response.data.rows);
  //     } catch (error) {
  //       console.error('Error fetching companies:', error);
  //     }
  //   };
  //   fetchHdtnlydo();
  // },[])
  // useEffect(() => {
  //   const fetchHdticket2phanloai = async () => {
  //     try {
  //       const response = await axiosi.get(`${process.env.REACT_APP_API_URL}/hdticket2phanloai`);
  //       setHdticket2phanloai(response.data.rows);
  //     } catch (error) {
  //       console.error('Error fetching companies:', error);
  //     }
  //   }
  //   fetchHdticket2phanloai();
  // },[])
  // useEffect(() => {
  //   const fetchHdtkstatus = async () => {
  //     try {
  //       const response = await axiosi.get(`${process.env.REACT_APP_API_URL}/hdtkstatus`);
  //       setHdtkstatus(response.data.rows);
  //     } catch (error) {
  //       console.error('Error fetching companies:', error);
  //     }
  //   } 
  //   fetchHdtkstatus();
  // },[])


  // const filteredCompanies = companies.filter(company =>
  //   company.name.toLowerCase().includes(searchValue.toLowerCase())
  // );
  const removeAccents = (str) => {
    if (!str) return '';
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  };
  const filterOptionRemoveAccents = (input, option) => {
    const normalizedInput = removeAccents(input.toLowerCase());
    const normalizedOption = removeAccents((option?.name ?? '').toLowerCase()); // Sử dụng option.label
    return normalizedOption.includes(normalizedInput);
  };
  return (
    <div className='formNoi'>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
      >
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="makhachhang"
              label="Mã Khách Hàng"
              rules={[{ required: true, message: 'Vui lòng nhập mã khách hàng!' }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="donvi"
              label="Đơn vị"
              rules={[{ required: true, message: 'Vui lòng nhập đơn vị!' }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="email"
              label="Email"
              rules={[{ type: 'email', message: 'Email không hợp lệ!' }]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="nguoibao"
              label="Người báo"
              rules={[{ required: true, message: 'Vui lòng nhập người báo!' }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="sodienthoai"
              label="Số điện thoại"
              rules={[{ required: true, message: 'Vui lòng nhập số điện thoại!' }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="sonoibo"
              label="Số nội bộ"
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="phanloaikhachhang"
              label="Phân Loại Khách Hàng"
              rules={[{ required: true, message: 'Vui lòng chọn phân loại khách hàng!' }]}
            >
              <Select>

                {phanloaiKhachHang.map((item) => (
                  <Select.Option key={item.value} value={item.value}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="hang"
              label="Hãng"
            >

              <Select showSearch mode="multiple"

                // onSearch={value => setSearchValue(value)}
                filterOption={(input, option) =>
                  (option?.name ?? '').toLowerCase().includes(input.toLowerCase())
                }
                placeholder="Chọn hãng"

                optionFilterProp="children"
                fieldNames={{ label: 'name', value: 'value' }}
                options={companies}
                allowClear
              >

              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="kenh"
              label="Kênh"
              rules={[{ required: true, message: 'Vui lòng chọn kênh!' }]}

            >
              <Select
                showSearch
                placeholder="Chọn kênh"
                allowClear
              >
                {kenh_array.map((item) => (
                  <Select.Option key={item.value} value={item.value}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <div style={{ marginTop: 24 }}>
          <h3>Thông tin Ticket:</h3>
        </div>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="phatsinhloi"
              label="Phát sinh lỗi"
            >
              <Select>
                <Select.Option value="No">No</Select.Option>
                <Select.Option value="Yes">Yes</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="loidoai"
              label="Lỗi do ai"
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="phongbophan"
              label="Phòng/Bộ phận"
            >
              <Select
                showSearch
                // onSearch={value => setSearchValue(value)}
                // filterOption={(input, option) =>
                //   (option?.name ?? '').toLowerCase().includes(input.toLowerCase())
                // }
                filterOption={(input, option) => {
                  // Chuyển đổi cả input và option.name về dạng không dấu để so sánh
                  const removeAccents = (str) => {
                    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
                  };

                  const normalizedInput = removeAccents(input.toLowerCase());
                  const normalizedOption = removeAccents((option?.name ?? '').toLowerCase());

                  return normalizedOption.includes(normalizedInput);
                }}
                placeholder="Chọn phòng/bộ phận"

                optionFilterProp="children"
                fieldNames={{ label: 'name', value: 'value' }}
                options={hdtnphongban}
                allowClear

              >

              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="lydo"
              label="Lý do"
            >
              <Select
                showSearch
                placeholder="Chọn lý do"
                allowClear
                optionFilterProp="children"
                fieldNames={{ label: 'name', value: 'value' }}
                options={hdtnlydo}
                filterOption={(input, option) => {
                  // Chuyển đổi cả input và option.name về dạng không dấu để so sánh
                  const removeAccents = (str) => {
                    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
                  };
                  const normalizedInput = removeAccents(input.toLowerCase());
                  const normalizedOption = removeAccents((option?.name ?? '').toLowerCase());

                  return normalizedOption.includes(normalizedInput);
                }}
              >
                {/* Thêm các option lý do */}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="phanloai"
              label="Phân loại"
              rules={[{ required: true, message: 'Vui lòng chọn phân loại!' }]}
            >
              <Select
                showSearch
                placeholder="Chọn phân loại"
                allowClear
                optionFilterProp="children"
                fieldNames={{ label: 'name', value: 'value' }}
                options={hdticket2phanloai}
                // filterOption={filterOptionRemoveAccents}
                filterOption={(input, option) => {
                  // Chuyển đổi cả input và option.name về dạng không dấu để so sánh
                  const removeAccents = (str) => {
                    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
                  };

                  const normalizedInput = removeAccents(input.toLowerCase());
                  const normalizedOption = removeAccents((option?.name ?? '').toLowerCase());

                  return normalizedOption.includes(normalizedInput);
                }}
              // filterOption={{input, option}=>{return filterOptionRemoveAccents(input, option)}}
              >
                {/* Thêm các option phân loại */}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="soid"
              label="SO-id"
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="tinhtrang"
              label="Tình Trạng"
              rules={[{ required: true, message: 'Vui lòng chọn tình trạng!' }]}
            >
              <Select
                showSearch
                placeholder="Chọn tình trạng"
                options={hdtkstatus} // Đã được map thành {label, value}
                fieldNames={{ label: 'name', value: 'value' }}

                allowClear
                filterOption={filterOptionRemoveAccents}

              >

              </Select>
            </Form.Item>
          </Col>
          <Col span={16}>
            <Form.Item
              name="deadline"
              label="Deadline (resolution respond)"
              rules={[{ required: true, message: 'Vui lòng chọn deadline!' }]}
            >
              <DatePicker
                showTime
                format="YYYY-MM-DD HH:mm:ss"
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="noidung"
              label="Nội dung"
              rules={[{ required: true, message: 'Vui lòng nhập nội dung!' }]}
            >
              <Input.TextArea rows={4} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="huongxuly"
              label="Hướng xử lý"
            >
              <Input.TextArea rows={4} />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="giaiphapkhacphuc"
              label="Giải pháp khắc phục"
            >
              <Input.TextArea rows={4} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="ghichu"
              label="Ghi chú"
            >
              <Input.TextArea rows={4} />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16} justify="end" style={{ marginTop: 24 }}>
          <Col span={12}>
            <Button type="default" onClick={onClose} className="cancel-button">
              Hủy
            </Button>

          </Col>
          <Col span={12}>

            <Button type="primary" htmlType="submit" className="submit-button">
              Thêm mới
            </Button>
          </Col>
        </Row>
        {/* <Form.Item>
          <Button type="primary" htmlType="submit">
            Thêm mới
          </Button>
          <Button style={{ marginLeft: 8 }} onClick={onClose}>
            Hủy
          </Button>
        </Form.Item> */}
      </Form>
    </div>
  );
}